import React, { Component } from "react";
import firebase from '../../firebase';
import {Grid, GridColumn, GridRow, Header, HeaderContent, Icon, Dropdown,Image} from 'semantic-ui-react';

class UserPanel extends Component {
state={
    user:this.props.currentUser
}
dropDownOptions=()=>[
{   key:"user",
text:(<span>Signed in as <strong>{this.state.user.displayName}</strong></span>),
disabled:true
},
{   key:"avatar",
    text:<span>Change Avatar</span>
},
{
    key:"signout",
    text:(<span onClick={this.handleSignOut}>Sign Out</span>)
}]

handleSignOut=()=>{
firebase
.auth()
.signOut()
.then(()=>console.log("Signed Out!"));    
}
    render() { 
        const {user} =this.state;
        return (
<Grid style={{background:'#4c3c4c'}}>
    <GridColumn>
        <GridRow style={{padding: '1.2em', margin:0}}>
{/*App Header*/}
<Header inverted floated="left" as='h2'>
    <Icon name='code'/>
    <HeaderContent>MeetUp</HeaderContent>
</Header>
  {/*User Dropdown*/}
        <Header style={{padding:'0.25em'}} as="h4" inverted>
            <Dropdown trigger={
                <span>
                    <Image src={user.photoURL} spaced="right" avatar />
                    {user.displayName}</span>
            }
            options={this.dropDownOptions()}/>
        </Header>
        </GridRow>
       </GridColumn>
</Grid>
          );
    }
}


export default UserPanel;


// WEBPACK FOOTER //
// ./src/components/SidePanel/UserPanel.js